// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Bns3I","imgContainer":"Card_imgContainer__wmBQJ","formContainer":"Card_formContainer__VVGt+"};